import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-passwordcontent',
  

  templateUrl: './passwordcontent.component.html',
  styleUrls: ['./passwordcontent.component.scss']
})
export class PasswordcontentComponent implements OnInit {

  constructor(public dialogRef: MatDialogRef<PasswordcontentComponent>) { }

  ngOnInit(): void {
    this.dialogRef.afterClosed().subscribe(result => {
      // Perform actions or handle the result here
    });
  }

}
